// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Link, Typography } from '@mui/material';

// props
export interface LinkPhoneProps {
	phone: number | string;
	phoneCountry?: number | string;
}

export const LinkPhone = ({ phone, phoneCountry }: LinkPhoneProps) => {
	// hooks
	const { t } = useTranslation();

	if (phone) {
		return (
			<Link
				href={`tel:${phoneCountry || ''}${phone}`}
				sx={{ wordBreak: 'break-word' }}
				underline="hover">
				{phoneCountry ? `+${phoneCountry} ` : ''}
				{phone}
			</Link>
		);
	}

	return <Typography>{t('na')}</Typography>;
};
